module.exports = __webpack_public_path__ + "img/calculator.ee7a950c.png";